(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('PromoCode', PromoCode);

    PromoCode.$inject = ['$resource','DateUtils'];

    function PromoCode ($resource, DateUtils) {
        var resourceUrl =  'api/promo-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.expirationDate = DateUtils.convertDateTimeFromServer(data.expirationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
